<script setup>
import copyright from "@/components/copyright";
import { onBeforeUnmount, onMounted, ref, computed, reactive } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import { getToken } from "@/utils/auth";

const token = getToken();

// 基础平台icon
import basePng from "@/assets/images/entrance/base.png";
import baseHover from "@/assets/images/entrance/base-hover.png";

// 预算icon
import budget from "@/assets/images/entrance/budget.png";
import budgetHover from "@/assets/images/entrance/budget-hover.png";

// 库房icon
import storeroom from "@/assets/images/entrance/storeroom.png";
import storeroomHover from "@/assets/images/entrance/storeroom-hover.png";

// 营销icon
import marketing from "@/assets/images/entrance/marketing.png";
import marketingHover from "@/assets/images/entrance/marketing-hover.png";

// 工程icon
import project from "@/assets/images/entrance/project.png";
import projectHover from "@/assets/images/entrance/project-hover.png";

// 管网icon
import pipe from "@/assets/images/entrance/pipe.png";
import pipeHover from "@/assets/images/entrance/pipe-hover.png";

// cms icon
import cms from "@/assets/images/entrance/cms.png";
import cmsHover from "@/assets/images/entrance/cms-hover.png";

// iot icon
import iot from "@/assets/images/entrance/iot.png";
import iotHover from "@/assets/images/entrance/iot-hover.png";

// 二次供水 icon
import secondaryWaterSupply from "@/assets/images/entrance/SecondaryWaterSupply.png";
import secondaryWaterSupplyHover from "@/assets/images/entrance/SecondaryWaterSupply-hover.png";

// 厂站icon
import station from "@/assets/images/entrance/station.png";
import stationHover from "@/assets/images/entrance/station-hover.png";

// 流程中心icon
import flow from "@/assets/images/entrance/flow.png";
import flowHover from "@/assets/images/entrance/flow-hover.png";

// AI算法 icon
import AI from "@/assets/images/entrance/AI.png";
import AIHover from "@/assets/images/entrance/AI-hover.png";

// 运营平台
import operate from "@/assets/images/entrance/operate.png";
import operateHover from "@/assets/images/entrance/operate-hover.png";

// 供水大脑
import supplyBrain from "@/assets/images/entrance/supplyBrain.png";
import supplyBrainHover from "@/assets/images/entrance/supplyBrain-hover.png";

// 系统背景
import systemItem from "@/assets/images/entrance/systemItem.png";
import systemItemHover from "@/assets/images/entrance/systemItemHover.png";

// 箭头
import leftArrow from "@/assets/images/entrance/leftSwitch.png";
import rightArrow from "@/assets/images/entrance/rightSwitch.png";

// 地图
import mapImg from "@/assets/images/entrance/earth.png";
import circle1 from "@/assets/images/entrance/circle1.png";
import earthCircle from "@/assets/images/entrance/earthCircle.png";

const timer = ref(null);

const store = useStore();

const router = useRouter();

// 系统列表
const systemList = ref([]);

// 当前时间
const currentTime = ref(null);

// 当前日期
const currentDate = ref(null);

// 问候语
const hello = ref("上午");

// 菜单图标映射
const menuIcons = reactive({
  "1677238071789752320": [basePng, baseHover],
  "1680784981016317952": [budget, budgetHover],
  "1683679191499186176": [storeroom, storeroomHover],
  "1684505905062125568": [marketing, marketingHover],
  "1685912754688794624": [project, projectHover],
  "1686990513326432256": [pipe, pipeHover],
  "1693503007503065088": [flow, flowHover],
  "1716630331786174464": [AI, AIHover],
  "1717004391934238720": [cms, cmsHover],
  "1719259338876821504": [iot, iotHover],
  "1722058280819662848": [operate, operateHover],
  1: [secondaryWaterSupply, secondaryWaterSupplyHover],
  supplyBrain: [supplyBrain, supplyBrainHover],
  "1866770940737052672": [station, stationHover],
  iotPlatform: [iot, iotHover]
});

const userInfo = computed(() => store.getters.userInfo);

const getTime = () => {
  timer.value = setInterval(() => {
    /* 时间 */
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0"); // 补齐两位数
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    currentTime.value = `${hours}:${minutes}:${seconds}`;
  }, 1000);
};

const getDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0"); // 月份从0开始，需要加1
  const day = String(now.getDate()).padStart(2, "0");
  let hour = now.getHours();

  if (hour < 12) {
    hello.value = "上午";
  } else if (hour < 18) {
    hello.value = "下午";
  } else {
    hello.value = "晚上";
  }

  currentDate.value = `${year}年${month}月${day}日`;
};

const switchPage = (type) => {
  if (type == "left") {
    showPage.value = 1;
  } else if (type == "right") {
    showPage.value = 2;
  }
};

// 获取系统列表
const getSystemList = () => {
  systemList.value = [];
  if (store.getters.userInfo) {
    if (store.getters.userInfo.menuTree.length > 0) {
      if (store.getters.userInfo.menuTree[0].menuCode == "1") {
        systemList.value = store.getters.userInfo.menuTree[0]?.children ?? [];
      } else {
        store.getters.userInfo.menuTree.forEach((item) => {
          if (item.menuCode !== "1" && item.menuType.value === "M") {
            systemList.value.push(item);
          }
        });
      }
    }
    // 二次供水 暂时隐藏
    // systemList.value.push({
    //   menuCode: 1,
    // });
    // 供水大脑
    const newItem = { menuCode: "supplyBrain", menuName: "供水大脑" };
    const exists = systemList.value.some(
      (item) => item.menuCode === newItem.menuCode
    );

    if (!exists) {
      systemList.value.push(newItem);
    }

    // iot平台
    const iotPlatform = { menuCode: "iotPlatform", menuName: "IOT-HUB" };
    const iotExists = systemList.value.some(
      (item) => item.menuCode === iotPlatform.menuCode
    );

    if (!iotExists) {
      systemList.value.push(iotPlatform);
    }
  } else {
    systemList.value = [];
  }
  systemList.value.map((i) => {
    i.isHover = 0;
  });
};

const showPage = ref(1);

const getPos = (index) => {
  switch (index) {
    case 0:
      return { x: 260, y: 600 };
    case 1:
      return { x: 430, y: 730 };
    case 2:
      return { x: 750, y: 800 };
    case 3:
      return { x: 1150, y: 800 };
    case 4:
      return { x: 1470, y: 730 };
    case 5:
      return { x: 1670, y: 600 };
    case 6:
      return { x: 260, y: 600 };
    case 7:
      return { x: 430, y: 730 };
    case 8:
      return { x: 750, y: 800 };
    case 9:
      return { x: 1150, y: 800 };
    case 10:
      return { x: 1470, y: 730 };
    case 11:
      return { x: 1670, y: 600 };
    case 12:
      return { x: 260, y: 600 };
    case 13:
      return { x: 430, y: 730 };
    case 14:
      return { x: 750, y: 800 };
    case 15:
      return { x: 1150, y: 800 };
    case 16:
      return { x: 1470, y: 730 };
    case 17:
      return { x: 1670, y: 600 };
    default:
      return { x: 0, y: 0 };
  }
};
const handleMouseOver = (item) => {
  item.isHover = 1;
};
const handleMouseLeave = (item) => {
  item.isHover = 0;
};

/** 点击系统 */
const clickSystem = (sys) => {
  if (sys.menuCode === "supplyBrain") {
    window.open(`${process.env.VUE_APP_WATER_SUPPLY}?token=${token}`);
    return;
  }
  if (sys.menuCode === "iotPlatform") {
    window.open(`${process.env.VUE_APP_IOT_PLATFORM_URL}`);
    return;
  }
  store.commit("permission/SET_SUB_SYSTEM_ID", sys.menuCode);
  sessionStorage.setItem("subSystemId", sys.menuCode);
  console.log("点击菜单跳转===>", sys, getRouter(sys));

  router.push({ path: getRouter(sys) });
};

// 根据点击的系统获取系统下的第一个菜单
const getRouter = (node) => {
  console.log(node);
  if (node.menuType.value === "C") {
    return node.frongRoute;
  } else {
    if (node.children && node.children.length > 0) {
      return getRouter(node.children[0]);
    }
  }
};

const logout = () => {
  ElMessageBox.confirm("是否退出登录？", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning"
  })
    .then(() => {
      store.dispatch("userInfo/LogOut").then(() => {
        store.commit("permission/SET_SUB_SYSTEM_NAME", "");
        store.commit("permission/SET_ROUTE_TABS", []);
        store.commit("permission/SET_SUB_SYSTEM_ID", "");
        router.replace("/login");
      });
    })
    .catch(() => {});
};

onMounted(() => {
  getTime();
  getDate();
  getSystemList();
});

onBeforeUnmount(() => {
  /* 关闭页面销毁所有定时器 */
  clearInterval(timer.value);
});
</script>

<template>
  <div class="container">
    <div class="title">
      <div class="date-time">
        <div class="time">{{ currentTime }}</div>
        <div class="date">{{ currentDate }}</div>
      </div>
      <img class="map_wrapper" :src="mapImg" alt="" />
      <img class="circle_wrapper" :src="circle1" alt="" />
      <img class="earthCircle" :src="earthCircle" alt="" />
      <div class="union_points">
        <div v-for="item of 11" :key="item" :class="[`line line${item}`]"></div>
      </div>
      <el-dropdown>
        <div class="welcome">
          <el-avatar
            :size="24"
            v-if="userInfo.fileVO && userInfo.fileVO.path"
            :src="userInfo.fileVO && userInfo.fileVO.path"
          ></el-avatar>
          <el-button
            type="primary"
            circle
            v-else
            style="width: 22px; height: 22px"
          >
            {{
              userInfo
                ? userInfo.nikeName
                  ? userInfo.nikeName[0]
                  : userInfo.userName[0]
                : "管"
            }}</el-button
          >
          <div class="nickname">
            {{
              `${hello}好，欢迎${
                userInfo
                  ? userInfo.nikeName
                    ? userInfo.nikeName
                    : userInfo.userName
                  : "管理员"
              }登陆`
            }}
          </div>
        </div>
        <template #dropdown>
          <el-dropdown-item @click="logout">安全退出</el-dropdown-item>
        </template>
      </el-dropdown>
    </div>
    <div class="leftArrow" @click="switchPage('left')" />
    <div class="rightArrow" @click="switchPage('right')" />
    <div
      @click="clickSystem(item)"
      :class="`${'circleItem' + index}`"
      v-for="(item, index) in systemList"
      :key="item"
      :style="{
        position: 'absolute',
        transform: 'translate(-50%, -50%)'
      }"
      @mouseover="handleMouseOver(item)"
      @mouseleave="handleMouseLeave(item)"
    >
      <div
        class="itemSize"
        v-if="
          showPage == 1
            ? index < 6
            : showPage == 2
            ? index > 5 && index < 12
            : index > 11
        "
      >
        <div class="imgSize">
          <div class="itemName">{{ item.menuName }}</div>
        </div>
      </div>
    </div>
    <div class="footer">
      <copyright :isBackgroundWhite="false" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/images/entrance/bg4.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  position: relative;
  .map_wrapper {
    position: absolute;
    top: 350px;
    width: 560px;
    height: 315px;
    transform: translate(-50%, -50%);
    left: 50%;
  }
  .circle_wrapper {
    position: absolute;
    top: 550px;
    width: 950px;
    transform: translate(-50%, -50%);
    left: 50%;
  }
  .earthCircle {
    position: absolute;
    top: 350px;
    width: 1100px;
    transform: translate(-50%, -50%);
    left: 50%;
  }
  .union_points {
    width: 292px;
    height: 215px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    overflow: hidden;
    position: absolute;
    top: 550px;
    left: 50%;
    transform: translate(-50%, -50%);
    .line {
      width: 2px;
      height: 80px;
      background: linear-gradient(
        to bottom,
        rgba(42, 153, 255, 0.1) 50%,
        rgb(153, 247, 250) 0%,
        rgba(42, 153, 255, 0.1) 100%
      );
    }
    .line1 {
      animation: line1 1s linear infinite;
    }
    .line2 {
      animation: line1 0.5s 0.2s linear infinite;
    }
    .line3 {
      animation: line1 1.5s 0.5s linear infinite;
    }
    .line4 {
      animation: line1 1.3s 1s linear infinite;
    }
    .line5 {
      animation: line1 1.6s 0.3s linear infinite;
    }
    .line6 {
      animation: line1 2s 0.4s linear infinite;
    }
    .line7 {
      animation: line1 1.2s 0.6s linear infinite;
    }
    .line8 {
      animation: line1 1.1s 1.1s linear infinite;
    }
    .line9 {
      animation: line1 1.9s 0.9s linear infinite;
    }
    .line10 {
      animation: line1 1.7s 1.3s linear infinite;
    }
    .line11 {
      animation: line1 1.3s 1.1s linear infinite;
    }
    .line12 {
      animation: line1 1.4s 0.4s linear infinite;
    }
  }
  .circleItem0 {
    left: 260px;
    top: 600px;
  }
  .circleItem1 {
    left: 430px;
    top: 750px;
  }
  .circleItem2 {
    left: 750px;
    top: 850px;
  }
  .circleItem3 {
    left: 1150px;
    top: 850px;
  }
  .circleItem4 {
    left: 1470px;
    top: 750px;
  }
  .circleItem5 {
    left: 1670px;
    top: 600px;
  }
  .circleItem6 {
    left: 260px;
    top: 600px;
  }
  .circleItem7 {
    left: 430px;
    top: 750px;
  }
  .circleItem8 {
    left: 750px;
    top: 850px;
  }
  .circleItem9 {
    left: 1150px;
    top: 850px;
  }
  .circleItem10 {
    left: 1470px;
    top: 750px;
  }
  .circleItem11 {
    left: 1670px;
    top: 600px;
  }
  .leftArrow {
    position: absolute;
    top: 380px;
    left: 80px;
    cursor: pointer;
    width: 90px;
    height: 90px;
    background-image: url("../../assets/images/entrance/leftSwitch.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: 50%;
  }
  .rightArrow {
    position: absolute;
    top: 380px;
    right: 80px;
    cursor: pointer;
    width: 90px;
    height: 90px;
    background-image: url("../../assets/images/entrance/rightSwitch.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: 50%;
  }
  .leftArrow:hover {
    background-image: url("../../assets/images/entrance/leftSwitchLight.png");
  }
  .rightArrow:hover {
    background-image: url("../../assets/images/entrance/rightSwitchLight.png");
  }
  .itemSize {
    height: 150px;
    position: relative;

    .imgSize {
      width: 120px;
      height: 150px;
      background-image: url("../../assets/images/entrance/systemItem.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: 50%;
      cursor: pointer;
      display: flex;
      justify-content: center;
      .itemName {
        font-size: 24px;
        color: white;
        position: absolute;
        top: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .imgSize:hover {
      margin-top: -40px;
      width: 170px;
      height: 200px;
      background-image: url("../../assets/images/entrance/systemItemHover.png");
      .itemName {
        top: 40px;
      }
    }
  }
  .title {
    width: 100%;
    height: 90px;
    flex-shrink: 0;
    background-image: url("../../assets/images/entrance/title_gr.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: 50%;

    color: #fff;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 20px 140px;

    .date-time {
      width: 216px;
      height: 29px;
      display: flex;
      align-items: center;
      flex-shrink: 0;

      .time {
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
      }
      .date {
        font-size: 12px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.7);
        margin-left: 10px;
      }
    }
    .welcome {
      display: inline-flex;
      gap: 8px;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 14px;
      height: 40%;
      color: #fff;
      cursor: pointer;

      img {
        width: 24px;
        height: 20px;
        border-radius: 50%;
      }

      .nickname {
        font-size: 14px;
        font-weight: 400;
        margin-top: 5px;
      }
    }
  }
}
@keyframes line1 {
  0% {
    transform: translateY(220px);
  }
  100% {
    transform: translateY(-220px);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes rotate-n {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(-360deg);
  }
}

@keyframes swing {
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(15deg);
  }

  100% {
    transform: rotate(0deg);
  }
}
</style>
